import { render, staticRenderFns } from "./DetailsCompanyView.vue?vue&type=template&id=196c2583&scoped=true"
import script from "./DetailsCompanyView.vue?vue&type=script&lang=ts"
export * from "./DetailsCompanyView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196c2583",
  null
  
)

export default component.exports